import { Alert, AlertColor, Snackbar, SnackbarOrigin } from '@mui/material';
import React, { useCallback, useState } from 'react';

interface SnackbarAlertState {
  isOpen: boolean;
  message: string;
  severity: AlertColor;
  autoHideDuration?: number | null;
}

type SetSnackbarAlert = (message: string, severity: AlertColor, autoHideDuration?: number | null) => void;

export function useSnackbarAlert(anchorOrigin: SnackbarOrigin = { vertical: 'bottom', horizontal: 'center' }): {
  SnackbarAlert: React.FC;
  setSnackbarAlert: SetSnackbarAlert;
} {
  const [state, setState] = useState<SnackbarAlertState>({
    isOpen: false,
    message: '',
    severity: 'info'
  });

  const setSnackbarAlert: SetSnackbarAlert = useCallback((message, severity, autoHideDuration) => {
    setState({ isOpen: true, message, severity, autoHideDuration });
  }, []);

  const handleClose = useCallback((_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const SnackbarAlert = () => (
    <Snackbar
      open={state.isOpen}
      autoHideDuration={state.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert onClose={handleClose} severity={state.severity} sx={{ width: '100%' }} elevation={6} variant="filled">
        {state.message}
      </Alert>
    </Snackbar>
  );

  return { SnackbarAlert, setSnackbarAlert };
}
